import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('TransportationGroup?page=' + page,  {params});
    }, 
    show(id) {
        return Service().get('TransportationGroup/show/'+id);
    },    
    create(params) {
        return Service().post('TransportationGroup/create', params);
    },
    update(id, params) {
        return Service().post('TransportationGroup/update/'+id, params);
    },
    delete(id) {
        return Service().post('TransportationGroup/delete/'+id);
    }
}